import { EDITOR_MODE } from "@pathwright/blocks-engine"
import FlashcardsContainer from "./FlashcardsContainer"

const FlashcardsView = (props) => {
  return <FlashcardsContainer {...props} mode={EDITOR_MODE.VIEW} />
}

export default FlashcardsView
